import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"

import { v4 as uuid } from 'uuid';
import parse from 'html-react-parser';
// services
import * as webBridgeService from '../../../services/webBridgeService'
import * as tokenService from '../../../services/tokenService'
import * as siteManagementService from '../../../services/siteManagementService'
// styles
import styles from "./LeadCaptureOrder.module.css"
// ------ Components ------ //
import LCProduct from "../../../components/LeadCapture/LeadCaptureOrder/LCProduct"
import LoadingSpinner from "../../Miscellaneous/LoadingSpinner"
import HoverButton from '../../../components/Miscellaneous/HoverButton'
const LeadCaptureOrder = () => {
    const timeoutRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate()
    const { refNumber } = useParams()
    const [loaded, setLoaded] = useState(false);
    const [user, setUser] = useState([]);
    const [products, setProducts] = useState([]);
    const [totalCost, setTotalCost] = useState(0);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const unique_id = uuid();
    const [txtCaptchaHidden, setTxtCaptchaHidden] = useState(null)
    const [txtCaptcha, setTxtCaptcha] = useState(null)
    const [captchaInput, setCaptchaInput] = useState(null)
    const [captchaDiv, setCaptchaDiv] = useState(null)
    const [auth, setAuth] = useState(false)
    const [byPass, setByPass] = useState(false)
    const [passcode, setPasscode] = useState([''])
    const [eventItem, setEventItem] = useState({});
    const [headerFile, setHeaderFile] = useState();
    const [formData, setFormData] = useState(
        {
            id: unique_id,
            leadCaptureRefNumber: refNumber && refNumber !== undefined ? refNumber : null,
            leadCaptureName: null,
            address: null,
            city: null,
            organization: null,
            countryName: 'United States',
            country: {},
            stateName: null,
            state: {},
            exEmail: null,
            exFirstName: null,
            exLastName: null,
            email: null,    //ohoy/bot catches
            firstName: null,//ohoy/bot catches
            lastName: null,//ohoy/bot catches
            passcode: null,
            isAdmin: false,
        }
    )
    const clearForm = () => {
        let holder = refNumber && refNumber !== undefined ? refNumber : null;
        setFormData({
            id: unique_id,
            leadCaptureRefNumber: holder,
            leadCaptureName: null,
            address: null,
            city: null,
            organization: null,
            countryName: 'United States',
            stateName: null,
            exEmail: null,
            exFirstName: null,
            exLastName: null,
            email: null,    //ohoy/bot catches
            firstName: null,//ohoy/bot catches
            lastName: null,//ohoy/bot catches
            passcode: null,
            postalCode: null,
            isAdmin: false,
        })
        setPasscode(null);
        setAuth(false);
        setByPass(false);
        fetchEvent(holder);
        setCaptchaInput(null);
    }
    const updateProduct = async (updatedProduct) => {
        // determine selected value's index to match numeric values on controller method for reload
        const index = products.findIndex(pcl => pcl.id === updatedProduct.id);
        let productsHolder = [...products]; // important to create a copy, otherwise you'll modify state outside of setState call
        productsHolder[index] = updatedProduct;
        setProducts(productsHolder)
    }
    const updateTotalCost = async () => {
        let newCost = 0
        if (products && products.length > 0) {
            products.forEach((item) => {
                if (item.total && item.total > 0) {
                    newCost += item.total;
                }
            })
            setTotalCost(newCost);
        }
    }
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const base64 = reader.result.split(',')[1]
                resolve(base64)
            }
            reader.onerror = (error) => {
                reject(error)
            }
        })
    }
    const fetchAttachments = async () => {
        const attachmentItems = await webBridgeService.fetchAttachments();
        if (attachmentItems && attachmentItems.length > 0) {
            setAttachments(attachmentItems);
        }
        else {
            setAttachments([]);
        }
    }
    const getUser = async () => {
        let userInfo = tokenService.getUserFromToken();
        if (userInfo) {
            setUser(userInfo);
        }
    }
    const getCountries = async () => {
        let countrieslist = await webBridgeService.getCountries();
        if (countrieslist && countrieslist.length > 0) {
            // reorder countries so US is first
            let USA = countrieslist.find((item) => item.countryKey === 'US');
            let OtherCountries = countrieslist.filter((item) => item.countryKey !== 'US');
            OtherCountries.unshift(USA);
            setCountries(OtherCountries)
        }
        else {
            setCountries(countrieslist)
        }

    }
    const getStates = async () => {
        let stateList = await webBridgeService.getStates();
        setStates(stateList)
    }
    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            if (e.target.name === 'stateName') {
                var foundState = states.find((item) => item.stateName === e.target.value);
                if (foundState) {
                    setFormData({ ...formData, state: foundState, stateName: foundState.stateName })
                }
                else {
                    setFormData({ ...formData, state: {}, stateName: null })
                }

            }
            if (e.target.name === 'countryName') {
                var foundCountry = countries.find((item) => item.countryName === e.target.value);
                if (foundCountry) {
                    setFormData({ ...formData, country: foundCountry, countryName: foundCountry.countryName })
                }
                else {
                    setFormData({ ...formData, country: {}, countryName: null })
                }

            }
        }
        else if (e.target.type === 'checkbox') {
            if (e.target.name === 'auth') {
                setAuth(e.target.checked);
            }
            if (e.target.name === 'byPass') {
                setByPass(e.target.checked);
            }
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
            if (e.target.name === 'organization') {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => {
                    // Perform action here, e.g., call an API
                    fetchPasscode(e.target.value);
                }, 2500); // Delay of 2500 milliseconds
                //setPasscode(e.target.value);
            }
            if (e.target.name === 'txtCaptcha') {
                setTxtCaptcha(e.target.value);
            }
            if (e.target.name === 'captchaInput') {
                setCaptchaInput(e.target.value);
            }
            if (e.target.name === 'captchaDiv') {
                setCaptchaDiv(e.target.value);
            }
        }
    }
    const fetchEvent = async () => {
        const item = await webBridgeService.fetchLeadCaptureByRefNumber(refNumber);
        if (item) {
            setEventItem(item);
            if (item.headerBase64Image) {
                setHeaderFile(item.headerBase64Image)
            }
            if (item.products && item.products.length > 0) {
                setProducts(item.products);
            }
        }
        setLoaded(true);
    }
    const createPasscodeRequest = (newPasscode) => {
        const fields = {
            passcode: newPasscode,
            id: formData.id,
        }

        return fields
    }
    const fetchPasscode = async (newPasscode) => {
        const pascodeReq = createPasscodeRequest(newPasscode);
        const passcodeItem = await webBridgeService.retrievePasscode(pascodeReq);
        // set formdata
        if (passcodeItem) {
            setPasscode(passcodeItem)
        }
    }
    const changeDateFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        const dateFormatted = date.toLocaleDateString('en-us', options);
        const returnDate = dateFormatted.split(' ').slice(1).join('/')
        return returnDate
    }
    function removeSpaces(entry) {
        if (!entry || entry.length < 1) {
            return '';
        }
        return entry.split(' ').join('');
    }

    function checkForm() {
        var why = "";
        var str1 = removeSpaces(txtCaptcha);
        var str2 = removeSpaces(captchaInput);
        if (str1 === str2) {
            why = "";
        }
        else {
            why += "- The CAPTCHA Code Does Not Match.\n";
        }
        if (why !== "") {
            setTxtCaptchaHidden( why); 
        } else {
            setTxtCaptchaHidden(''); //Good

        }
    }
    // Validate input against the generated number
    function ValidCaptcha() {
        var str1 = removeSpaces(txtCaptcha);
        var str2 = removeSpaces(captchaInput);
        if (str1 === str2 && str1.length > 0 && str2.length > 0) {
            return true;
        } else {
            return false;
        }
    }
    const isFormValid = () => {
        return !(formData.exFirstName &&
            formData.exLastName &&
            formData.id &&
            formData.exEmail &&
            passcode &&
            auth &&
            ValidCaptcha());
    }
    const createSaveRequest = (items) => {
        let amountPaid = 0;
        let productOrdersItem = [];
        for (var i = 0; i < products.length; i++) {
            let item = products[i];
            let productOrderItem = {
                'id': item.id ? item.id : null,
                'productId': item.id,
                'quantity': item.quantity,
                'purchasePrice': item.purchasePrice,
                'cancelled': item.cancelled,

            };
            if (item.total && item.total > 0) {
                // keep a runnning tally
                amountPaid += item.total;
            }
            else if (item.quantity && item.purchasePrice) {
                // keep a runnning tally
                amountPaid += (item.quantity * item.purchasePrice);
            }
            productOrdersItem.push(productOrderItem);
        }
        let orderItem = {
            'id': formData.order && formData.order.id ? formData.order.id : null,
            'orderTotal': amountPaid,
            'paid': byPass !== undefined && byPass ? true : false,
            'bypassPayment': byPass !== undefined && byPass ? true : false,
            'cancelled': formData.cancelled,
        }
        // holder products and porductorders
        let invoiceItem = {
            'id': formData.invoice && formData.invoice.id ? formData.invoice.id : null,
            'invoiceNumber': formData.invoice && formData.invoice.invoiceNumber ? formData.invoice.invoiceNumber : null,
            'productOrders': productOrdersItem,
            'order': orderItem,
        }
        // holds everything
        const fieldsSave = {
            'exhibitorId': formData.id,
            'leadCaptureId': eventItem.id,
            'invoice': invoiceItem,
            'passcode': passcode,
            'organization': formData.organization,
            'firstName': formData.exFirstName,
            'lastName': formData.exLastName,
            'email': formData.exEmail,
            'address': formData.address,
            'city': formData.city,
            'stateName': formData.stateName,
            'countryName': formData.countryName,
            'postalCode': formData.postalCode,
            // get mobile image in the backend from the lead capture
            //'mobileBase64Image': formData.mobileBase64Image ? formData.mobileBase64Image : leadCapture.mobileBase64Image ? leadCapture.mobileBase64Image : null,
            //'mobileImageExtension': formData.mobileImageExtension ? formData.mobileImageExtension : leadCapture.mobileImageExtension ? leadCapture.mobileImageExtension : '.jpg',
        }
        return fieldsSave
    }
    const handleSubmit = async e => {
        e.preventDefault()
        try {
            // check the bots fields
            if (formData.firstname || formData.lastName || formData.email) {
                // assume its a bot, go to confirmation page, but don't create/save account
                // pass invoiceid of 0, to  force naivgation/show nothing - to confuse bots
                // catch within web api confirmation method will prevent email from being sent
                formData.invoice = { invoiceNumer: 0};
                navigate('/Confirmation', { state: formData });
            }
            let saveReq =  await createSaveRequest();
            //navigate('/ExhibitorList'); navigate to purchase
            // pass payform from backend? or, build in react?
            let savedExhibitor = await webBridgeService.updateExhibitor(saveReq); //await webBridgeService.fetchExhibitorByInvoiceNumber(1);//await webBridgeService.updateExhibitor(saveReq); DS testing
            savedExhibitor.leadCaptureId = eventItem.id;
            if (byPass !== undefined && byPass) {
                // go to confirmation page
                // pass invoiceid, pull info and display - use what was returned?
                let payForm = await siteManagementService.getPayform(savedExhibitor);
                navigate('/Confirmation', { state: payForm });
            }
            else {
                let payForm = await siteManagementService.getPayform(savedExhibitor);
                //navigate('/paypalpurchase'); navigate to paypal purchase screen
                navigate('/PayForm', { state: payForm });
            }
            
        } catch (err) {
            //setMessage(err.message)
        }
    }
    useEffect(() => {
        if (products && products.length >0) {
            updateTotalCost();
        }
    }, [products])
    useEffect(() => {
        if (captchaInput && captchaInput !== undefined && captchaInput.length >0) {
            checkForm();
        }
    }, [captchaInput])
    useEffect(() => {
        //window.addEventListener("keyup", (e) => {
        //    checkForm();
        //});
        var a = Math.ceil(Math.random() * 9) + '';
        var b = Math.ceil(Math.random() * 9) + '';
        var c = Math.ceil(Math.random() * 9) + '';
        var d = Math.ceil(Math.random() * 9) + '';
        var e = Math.ceil(Math.random() * 9) + '';
        var code = a + b + c + d + e;
        setTxtCaptcha(code); 
        setCaptchaDiv(code); 
    }, [loaded]);
    useEffect(() => {
        // used for dropdowns/extra details
        // make sure they loaded
        if (!attachments || attachments.length < 1) {
            fetchAttachments();
        }
        if (!countries || countries.length < 1) {
            getCountries();
        }
        if (!states || states.length < 1) {
            getStates();
        }
    }, [loaded])
    useEffect(() => {
        // used for dropdowns/extra details
        fetchAttachments();
        getCountries();
        getStates();
        getUser();
        if (refNumber && refNumber !== undefined) {
            fetchEvent();
        }
        else {
            setLoaded(true);
        }
    }, [])
    return (
        <>{!loaded ? <LoadingSpinner /> :
            <>
                <div style={{ background: 'white' }}>
                    <img className={styles.header} src={headerFile} style={{ width: eventItem.headerImageWidth, height: eventItem.headerImageHeight, display: 'block', margin: 'auto' }} />
                    <h1> Purchase services for {eventItem.overwriteName}</h1>
                    <div className={styles.leadCaptureContainer}>
                        <h2>Profile Details</h2>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="exEmail" className={styles.label}>Email Address:
                                            <HoverButton
                                                title={'Account email.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="1"
                                            type="text"
                                            autoComplete="off"
                                            name="exEmail"
                                            value={formData.exEmail}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="organization" className={styles.label}>Organization:
                                            <HoverButton
                                                title={'Account organization.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="2"
                                            type="text"
                                            autoComplete="off"
                                            name="organization"
                                            value={formData.organization}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="exFirstName" className={styles.label}>First Name:
                                            <HoverButton
                                                title={'Account first name.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="3"
                                            type="text"
                                            autoComplete="off"
                                            name="exFirstName"
                                            value={formData.exFirstName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="exLastName" className={styles.label}>Last Name:
                                            <HoverButton
                                                title={'Account last name.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="5"
                                            type="text"
                                            autoComplete="off"
                                            name="exLastName"
                                            value={formData.exLastName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="address" className={styles.label}>Street Address:
                                            <HoverButton
                                                title={'Account street address.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="5"
                                            type="text"
                                            autoComplete="off"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="city" className={styles.label}>City:
                                            <HoverButton
                                                title={'Account city.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="6"
                                            type="text"
                                            autoComplete="off"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer} key={formData.countryName}>
                                    {
                                        formData.countryName && formData.countryName === 'United States' ?
                                            <>
                                                <div className={styles.leftContainer}>
                                                    <label htmlFor="stateName" className={styles.label}>State:
                                                        <HoverButton
                                                            title={'Account state.'}
                                                            messageWidth={75}
                                                        />
                                                    </label>
                                                </div>
                                                <div className={styles.rightContainer}>
                                                    <select
                                                        tabIndex="7"
                                                        name="stateName"
                                                        id={styles.ThirdPartyListDropdown}
                                                        value={formData.stateName}
                                                        onChange={handleChange}
                                                    >
                                                        <option disabled={true} value="" selected="selected">
                                                            -- Select an option --
                                                        </option>
                                                        {
                                                            states.map((ci, idx) => (
                                                                <option key={idx}>{ci.stateName}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </>
                                            : <>
                                            </>
                                    }

                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="countryName" className={styles.label}>Country:
                                            <HoverButton
                                                title={'Account country.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <select
                                            tabIndex="7"
                                            name="countryName"
                                            id={styles.ThirdPartyListDropdown}
                                            value={formData.countryName}
                                            onChange={handleChange}
                                            style={{
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <option disabled={true} value="" selected="selected">
                                                -- Select an option --
                                            </option>
                                            {
                                                countries.map((ci, idx) => (
                                                    <option key={idx}>{ci.countryName}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="postalCode" className={styles.label}>Postal Code:
                                            <HoverButton
                                                title={'Account postal code.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="9"
                                            type="text"
                                            autoComplete="off"
                                            name="postalCode"
                                            value={formData.postalCode}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div id="Ohoy">
                            <div className={styles.ohoy}>
                                <div className={styles.ohoy}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={styles.ohoy}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className={styles.ohoy}>
                                <div className={styles.ohoy}>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={styles.leadCaptureContainer}>
                        <h2>Service Options</h2>
                        <h4><strong>All prices in US dollars.</strong></h4>
                        {products && products.length > 0 && attachments && attachments.length > 0 ?
                            <>
                                <table className={styles.tableProducts}>
                                    <thead>
                                        <tr className={styles.trProducts}>
                                            <th style={{
                                                width: '65%', textAlign: 'center',
                                                backgroundColor: 'white',
                                                borderColor: 'white'
                                            }}>
                                                Service Name
                                                <HoverButton
                                                    title={'Label for service.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th style={{
                                                width: '5%', textAlign: 'center',
                                                backgroundColor: 'white',
                                                borderColor: 'white'
                                            }}>
                                                Price Before {changeDateFormat(eventItem.eventStartDate)}
                                                <HoverButton
                                                    title={'Price before early registration deadline.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th style={{
                                                width: '5%', textAlign: 'center',
                                                backgroundColor: 'white',
                                                borderColor: 'white'
                                            }}>
                                                Price After {changeDateFormat(eventItem.eventStartDate)}
                                                <HoverButton
                                                    title={'Price after early registration deadline.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th style={{
                                                width: '5%', textAlign: 'center',
                                                backgroundColor: 'white',
                                                borderColor: 'white'
                                            }}>
                                                Promo Code
                                                <HoverButton
                                                    title={'Acceptable promocode.'}
                                                    messageWidth={75}
                                                />
                                            </th>

                                            <th style={{
                                                width: '5%', textAlign: 'center',
                                                backgroundColor: 'white',
                                                borderColor: 'white'
                                            }}>
                                                Quantity
                                                <HoverButton
                                                    title={'Number to purchase.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th style={{
                                                width: '15%', textAlign: 'center',
                                                backgroundColor: 'white',
                                                borderColor: 'white'
                                            }}>
                                                Service Total
                                                <HoverButton
                                                    title={'Line item price.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody key={products.length}>
                                        {products.map((item, index) => (
                                            (!item.isAdmin || (item.isAdmin && user && (user.Role === "SuperAdmin" || user.Role === "Admin") && item)) ?
                                                <LCProduct
                                                    index={index}
                                                    productItem={item}
                                                    attachments={attachments}
                                                    eventItem={eventItem}
                                                    updateProduct={updateProduct}
                                                    key={index}
                                                ></LCProduct>
                                                : <></>
                                        ))}
                                    </tbody>
                                </table>
                            </>

                            :
                            <div> No Services for Lead Capture!</div>
                        }
                        <br /><br />
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <strong> Total Cost:</strong>
                            </div>
                            <div className={styles.rightContainer}>
                                {totalCost && totalCost !== undefined ? '$ ' + totalCost.toLocaleString('en-US') : 0}
                            </div>
                        </div>
                    </div><br /><br />
                    <div className={styles.leadCaptureContainer}>
                        {eventItem.statements && eventItem.statements.termsAndConditions ? parse(eventItem.statements.termsAndConditions) : <></>}
                    </div>
                    <br /><br />
                    <div className={styles.leadCaptureContainer}>
                        <h2>  Authorization  </h2> <br />
                        <input
                            type="checkbox"
                            autoComplete="off"
                            checked={auth ? true : false}
                            name="auth"
                            onChange={handleChange}
                        />
                        {eventItem.statements && eventItem.statements.authStatement ? parse(eventItem.statements.authStatement) : <></>}
                    </div>
                    {
                        user && (user.Role === "SuperAdmin" || user.Role === "Admin") ?
                            <div className={styles.leadCaptureContainer}> <br /> <br />
                                <h3>Bypass Payment:</h3>
                                <input
                                    type="checkbox"
                                    autoComplete="off"
                                    checked={byPass ? true : false}
                                    name="byPass"
                                    onChange={handleChange}
                                />
                            </div>
                            : <></>
                    }

                    <br /><br />
                    <div className={styles.capbox}>
                        <div id='CaptchaDiv'>{captchaDiv}
                            <div className={styles.capboxInner}>
                                Type the number:<br />

                            </div>
                            <input
                                type="text"
                                autoComplete="off"
                                name="captchaInput"
                                value={captchaInput}
                                onChange={handleChange}
                                id="captchaInput"
                            /><br />
                            <input
                                type="hidden"
                                autoComplete="off"
                                name="txtCaptcha"
                                value={txtCaptcha}
                                onChange={handleChange}
                                id="txtCaptcha"
                            />
                        </div>
                    </div>
                    <div style={{ color: 'red' }}>
                        {txtCaptchaHidden}
                    </div>
                    <br /><br />
                    <button onClick={e => handleSubmit(e)} disabled={isFormValid()} className={styles.editButtons}>
                        Continue to payment...
                    </button>
                    <br /><br /><br /><br /> 
                </div>
                   
            </>

        }
        </>


    );
}
export default LeadCaptureOrder;